import { apiClient, bearer, unwrap } from './client';
import type { components } from './types';

export type IntakeOut = components['schemas']['IntakeOut'];
export type IntakeQuestion = components['schemas']['IntakeQuestion'];
export type IntakeAnswerValue = IntakeOut['answers'][string];
export type IntakeAnswers = Record<string, IntakeAnswerValue>;

export function getPortalIntake(engagementId: string, idToken: string): Promise<IntakeOut> {
  return apiClient
    .GET('/api/portal/engagements/{engagement_id}/intake', {
      params: { path: { engagement_id: engagementId } },
      headers: bearer(idToken),
    })
    .then(unwrap<IntakeOut>);
}

export function savePortalIntakeDraft(
  engagementId: string,
  answers: IntakeAnswers,
  idToken: string,
): Promise<IntakeOut> {
  return apiClient
    .PUT('/api/portal/engagements/{engagement_id}/intake', {
      params: { path: { engagement_id: engagementId } },
      body: { answers },
      headers: bearer(idToken),
    })
    .then(unwrap<IntakeOut>);
}

export function submitPortalIntake(engagementId: string, idToken: string): Promise<IntakeOut> {
  return apiClient
    .POST('/api/portal/engagements/{engagement_id}/intake/submit', {
      params: { path: { engagement_id: engagementId } },
      headers: bearer(idToken),
    })
    .then(unwrap<IntakeOut>);
}

/** Practitioner-side read of the same intake row. */
export function getEngagementIntake(engagementId: string, idToken: string): Promise<IntakeOut> {
  return apiClient
    .GET('/api/engagements/{engagement_id}/intake', {
      params: { path: { engagement_id: engagementId } },
      headers: bearer(idToken),
    })
    .then(unwrap<IntakeOut>);
}
